window.$ = window.jQuery = require('jquery');
window.slick = require('slick-carousel');
window.GSAP = require('gsap/all');

require('./utils');
require('./home');
require('./hero');
require('./helping');
require('./projects');
require('./interviews');
require('./pdfViewer');
require('./documents');
require('./tabs');
require('./news');
require('./slick');